module.exports = __webpack_public_path__ + "static/media/back3.9fcedd08.png";